<template>
	<base-nav container-classes="container-fluid" class="navbar-top navbar-expand"
		:class="{ 'bg-white navbar-dark': type === 'default' }">
		<!-- Search form -->
		<b-form class="navbar-search form-inline mr-sm-3"
			:class="{ 'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light' }"
			id="navbar-search-main">
			<b-form-group class="mb-0">
			</b-form-group>
			<button type="button" class="close" data-action="search-close" data-target="#navbar-search-main"
				aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</b-form>
		<!-- Navbar links -->
		<b-navbar-nav class=" align-items-center mr-md-auto">
			<!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
			<li class="nav-item d-xl-none">
				<!-- Sidenav toggler -->
				<div class="pr-3 sidenav-toggler"
					:class="{ active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light' }"
					@click="toggleSidebar">
					<div class="sidenav-toggler-inner">
						<i class="sidenav-toggler-line"></i>
						<i class="sidenav-toggler-line"></i>
						<i class="sidenav-toggler-line"></i>
					</div>
				</div>
			</li>
		</b-navbar-nav>
		<b-navbar-nav class="align-items-center ml-auto mr-md-0">
			<!-- notifications -->
			<base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
				<a href="javascript:void(0)" class="nav-link pr-0" @click.prevent slot="title-container">
					<b-media no-body class="align-items-center">
						<span class="avatar avatar-sm bg-white rounded-circle text-dark pt-2 position-relative">
							<h2><b-icon icon="bell">
								</b-icon></h2>
							<span
								class="position-absolute top-0 right-0 text-white text-center bg-danger rounded-circle font-weight-bold"
								style="width:22px;height:22px;font-size:10px;padding-top:3px"
								v-if="unreadNotifications.length > 0">{{ unreadNotifications.length }}</span>
						</span>
					</b-media>
				</a>
				<template>
					<b-dropdown-header class="noti-title" style="min-width: 300px;">
						<div class="d-flex align-items-center justify-content-between">
							<h6 class="text-overflow m-0">Notifications</h6>
							<!-- <h6 class="text-overflow m-0"><a href="javascript:void(0)" @click="
              ">All</a></h6> -->
							<b-dropdown size="sm" variant="transparent" right>
                <template #button-content>
                  <span class="h6 m-0">Category</span>
                </template>
                <b-dropdown-item
                  v-for="category in notificationCategories"
                  :key="category"
                  :class="{'bg-light': selectedCategory === category}"
                  @click.stop="filterNotifications(category)"
                >
                  {{ category }}
                </b-dropdown-item>
              </b-dropdown>	
						</div>
					</b-dropdown-header>
					<div class="px-1" style="max-height: 300px; overflow-y: scroll;">
						<ul class="list-group list-group-flush text-dark" v-if="ListNotifications.length > 0">
							<li class="list-group-item pt-2 pb-1 px-3" :class="notification.noti_read_at ? '' : 'bg-fintos'"
								@click.stop="markAsReadHandler(notification)" v-for="(notification, index) in ListNotifications"
								:key="index">
								<small>{{ notification.noti_message }}</small>
								<div class="d-flex justify-content-between mt-2 p-0">
									<small :class="notification.noti_read_at ? 'text-muted' : 'text-dark'" style="font-size:10px">{{
										notification.created_at | dateFormatString }}</small>
								</div>
							</li>
						</ul>
						<div class="px-2" v-else>
							<small class="px-1">You have no notifications.</small>
						</div>
					</div>
					<div v-if="unreadNotifications.length > 0">
						<div class="dropdown-divider"></div>
						<div class="text-center">
							<a href="javascript:void(0)" @click.stop="markAllAsRead">
								<small>Mark all as read.</small>
							</a>
						</div>
					</div>
				</template>
			</base-dropdown>

			<!-- user profile -->
			<base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
				<a href="javascript:void(0)" class="nav-link pr-0" @click.prevent slot="title-container">
					<b-media no-body class="align-items-center" v-if="_gAuth.activeUser('name')">
						<span class="avatar avatar-sm bg-dark rounded-circle text-white">
							<b>{{ _gHlp.formatInitials(_gAuth.activeUser('name')) }}</b>
						</span>
					</b-media>
				</a>
				<template>

					<b-dropdown-header class="noti-title">
						<h6 class="text-overflow m-0">Welcome, {{ _gAuth.activeUser('name') }}</h6>
					</b-dropdown-header>
					<b-dropdown-item @click="myProfile()">
						<i class="ni ni-single-02"></i>
						<span>My profile</span>
					</b-dropdown-item>
					<div class="dropdown-divider"></div>
					<b-dropdown-item @click="logoutFunction()">
						<i class="ni ni-user-run"></i>
						<span>Logout</span>
					</b-dropdown-item>

				</template>
			</base-dropdown>
		</b-navbar-nav>
	</base-nav>
</template>
<script>
import { BaseNav } from '@/components';
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { isEqual, cloneDeep } from 'lodash'

export default {
	components: {
		BaseNav
	},
	props: {
		type: {
			type: String,
			default: 'default', // default|light
			description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
		}
	},
	computed: {
		...mapState(useAuthStore, ['getLoginInfo']),
		...mapState(useNotificationStore, ['notifications', 'navbar_notifications']),
		routeName() {
			const { name } = this.$route;
			return this.capitalizeFirstLetter(name);
		},
		unreadNotifications(){
			const notif = cloneDeep(this.notifications);
			return notif.filter((item) => item.noti_read_at === null);
		},
		ListNotifications() {
			let unread = [];
			let read = [];
			const ctg = this.selectedCategory+":";
			if(this.selectedCategory != 'All'){
				unread = this.notifications.filter(item => item.noti_read_at === null && item.noti_message.includes(ctg));
				read = this.notifications.filter(item => item.noti_read_at != null && item.noti_message.includes(ctg));
			}else{
				unread = this.notifications.filter(item => item.noti_read_at === null);
				read = this.notifications.filter(item => item.noti_read_at != null);
			}

			let notif = [];
			if(!_gHlp.isEmpty(unread) && unread.length > 0){
				notif = unread
			}

			if(notif.length < 5 && !_gHlp.isEmpty(read) && read.length > 0){
				for (let i = 0; i < read.length; i++) {
					const el = read[i];
					notif.push(el);
					if(notif.length > 8){
						break;
					}
				}
			}
			return notif;
    }
	},
	created() {
		if (_gAuth.isLogin()) {
			this.getUserNotifications()
		}
	},
	data() {
		return {
			activeNotifications: false,
			showMenu: false,
			searchModalVisible: false,
			searchQuery: '',
			loginUserData: '',
			selectedCategory: 'All',
			notificationCategories: ['Customer', 'Pending Proposal', 'Loan Case', 'Disbursement', 'Collection', 'All'],
		};
	},
	methods: {
		...mapActions(useAuthStore, ['logout']),
		...mapActions(useNotificationStore, ['getUserNotifications', 'markAsRead', 'markAllAsRead']),
    async markAsReadHandler(notification){
      await this.markAsRead(notification)
      if(notification.noti_url){
        this.redirectNotificationURL(notification.noti_url)
      }
    },
    redirectNotificationURL(url){
			if(_gHlp.isValidURL(url)){
				window.location.href = url;
			}
    },
		filterNotifications(category) {
      // if (category === 'All' && this.selectedCategory === 'All') {
      //   if(this.$route.name !== 'notifications'){
			// 		this.$router.push('/notifications')
			// 	}
      // } else {
        this.selectedCategory = category;
      // }
    },
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		toggleNotificationDropDown() {
			this.activeNotifications = !this.activeNotifications;
		},
		closeDropDown() {
			this.activeNotifications = false;
		},
		toggleSidebar() {
			this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
		},
		hideSidebar() {
			this.$sidebar.displaySidebar(false);
		},
		logoutFunction() {
			this.logout().then(() => {
				this.$router.push({ name: 'Login' });
			});
		},
		myProfile() {
			this.$router.push({ name: 'My Profile' })
		},
	}
};
</script>
